// extracted by mini-css-extract-plugin
export default {"trustpilot":"trustpilot___jZIup","features":"features___j8RLi","feature":"feature___pD2ZD"};